module.exports = __webpack_public_path__ + "static/media/References.57118279.pdf";